// Configs
import { envList } from "configs"

export const isFlashSale = (value) => {
  return value === envList.flash_sale.from
}